<template>
<div class="w-top-block">
  <WStatistics v-if="authority.includes(127)" :data="statisticsData"></WStatistics>
</div>
</template>

<script>
import HOMEAPI from '@/api/svolt/home';
import {
  getInfo
} from '@/utils/auth';
import WStatistics from '../../components/w-statistics';
export default {
  components: {
    WStatistics
  },
  props: {
    auth: {
      type: [Number, String]
    }
  },
  data() {
    return {
      userInfo: {},
      authority: [], //权限
      statisticsData: [{
          key: 'saveCoal',
          src: '/static/images/svolt/coalIcon.png',
          number: '',
          desc: '节约标准煤（吨）'
        },
        {
          key: 'co2less',
          src: '/static/images/svolt/treeIcon.png',
          number: '',
          desc: '二氧化碳减排量（吨）'
        },
        {
          key: 'treeVolume',
          src: '/static/images/svolt/co2Icon.png',
          number: '',
          desc: '相当于植树（颗）'
        }
      ]
    };
  },
  methods: {
    //初始数据
    init() {
      let tempAuth = localStorage.getItem('ActiveModule');
      if (tempAuth) {
        let json = JSON.parse(tempAuth);
        this.authority = json.resourceIds;
        // console.log(json.item, '权限列表');
      }
      this.getUserInfo();
      if (this.authority.includes(127)) {
        this.searchSolarAndEnergyStorageIncomeAndSaveEmissions();
      }
    },
    //获取中间页面的统计数据
    async searchSolarAndEnergyStorageIncomeAndSaveEmissions() {
      let params = { groupId: this.userInfo.groupId };
      let res = await HOMEAPI.searchSolarAndEnergyStorageIncomeAndSaveEmissions(params);
      if (res.data.code == 200) {
        let result = res.data.data;
        this.statisticsData.map(item => {
          item.number = result[item.key];
        });
      }
    },
    //获取用户信息
    getUserInfo() {
      let info = getInfo();
      let tp = typeof info;
      if (tp == 'string') {
        this.userInfo = JSON.parse(info);
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.w-top-block {
  background: #F3F7FF;
  overflow: hidden;
  width: 100%;
  z-index: 10;
  // top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/home/components/w-top-block.vue